import { Resolver } from "react-hook-form";

import { IRepresentative } from "../../../../../../models/user/representatives/IRepresentative";

export const formResolver: Resolver<IRepresentative> = async (values: IRepresentative) => {
    let errors = {};
    Object.entries(values).forEach(([name, value]) => {
        if (!value) {
            errors = {
                ...errors,
                [name]: {
                    type: "required",
                    message: "FORM.VALIDATION.REQUIRE",
                },
            };
        }
    });
    return { values, errors };
};
